export default __webpack_public_path__ + "images/3c7855dec77c8f40d2470a69c2362de1-emoji-lonely.svg";